<template lang="html">
  <div class="flex flex-col h-full">
    <div class="flex justify-between align-baseline">
      <div class="font-medium text-lg w-1/2">
        Shooting board
      </div>
      <div class="w-1/2">
        <select data-tippy-content="Filter the shooting board by the status of the shooting frame."
                name="filter_shooting_board" v-model="selected_filter"
                class="border-none h-8 px-2 py-1 w-full text-sm dark:bg-gray-800 text-gray-500 dark:text-gray-200">
          <option value="show_all">All</option>
          <option value="only_not_completed">Not completed</option>
          <option value="only_completed">Completed</option>
        </select>
      </div>
    </div>
    <div class="pt-2" v-if="!isGuest">
      <select name="storyboards" class="form-input" data-e2e="shooting_board_test" v-model="selected_board"
              v-on:change="_loadShootingBoard()">
        <option value="none" selected>No shooting board</option>
        <option :value="-1" @click="showUploadFolderModal = true" v-if="!isGuest">Upload a folder</option>
        <option :value="shooting.id" v-for="shooting in shooting_boards">{{ shooting.title }}</option>
      </select>
    </div>
    <div class="overflow-y-scroll bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner mt-2 flex-grow" border-b-4 border-gray-100>
      <div v-if="filtered_shooting_frames.length">
        <transition-group name="slide-in" tag="div" class="grid grid-cols-1 gap-2" @before-leave="beforeLeave">
          <button data-e2e="frame_test" class="flex hover:bg-gray-200 dark:hover:bg-gray-700 w-full slide-in-item"
                  v-for="shooting_frame in filtered_shooting_frames"
                  @click="_renderFrameLightbox(shooting_frame)" v-bind:key="shooting_frame.id">
            <div class="relative opacity-50 hover:opacity-100 flex-shrink-0 w-24 h-16 bg-cover bg-center"
                 :style="'background-image: url('+shooting_frame.file_url+' )'">
              <!-- Cross icon -->
              <svg v-show="shooting_frame.completed_at"
                   class="w-12 h-12 fill-current text-red-600 absolute top-0 left-0 ml-4"
                   xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                      d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                      clip-rule="evenodd"/>
              </svg>
            </div>
            <div class="text-gray-800 dark:text-gray-200 pt-1 px-2 text-left flex-shrink w-2/3 h-full flex items-center">
              <div class="font-medium truncate">
                {{ shooting_frame.title }}
              </div>
            </div>
          </button>
        </transition-group>
      </div>
      <div class="text-gray-600 dark:text-gray-300 flex justify-center items-center h-full"
           v-if="filtered_shooting_frames.length == 0 && !isLoading">
        <div class="text-center">
          <span v-if="selected_board != 'none'">
            <span v-if="selected_filter == 'show_all'">
              Empty folder
            </span>
            <span v-else>
              There are no takes with this filter.
              <button class="underline" @click="selected_filter = 'show_all'">See all.</button>
            </span>
          </span>
          <span v-else>
            <span v-if="isGuest">
              The host has not published <br/> any shooting boards.
            </span>
            <span v-else>
              No folder selected
            </span>
          </span>
        </div>
      </div>
      <div class="text-gray-600 dark:text-gray-300 flex justify-center items-center h-full" v-if="isLoading">
        <div class="text-center">
          <div class="loader mx-auto mb-2"></div>
          Loading...
        </div>
      </div>
    </div>
    <modal :showModal="showLightbox" @close="closeLightbox()" classSize="lg:max-w-4xl">
      <div class="pt-4 md:pt-2">
        <div class="hidden md:block text-center rounded-md px-2 pb-2 mb-2">
        To speak while keeping your eyes on this graphic, press and hold the space bar
        </div>
        <div class="relative">
          <!-- Cross icon -->
          <svg v-show="selected_frame.completed_at" class="w-48 md:w-96 h-48 md:h-96 fill-current text-red-600 absolute inset-0 m-auto"
               xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill-rule="evenodd"
                  d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                  clip-rule="evenodd"/>
          </svg>
          <img :src="selected_frame.file_url" class="w-auto mx-auto max-h-80" id="lightboxImage"/>
        </div>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
            {{ selected_frame.title }}
          </h3>
          <div class="mt-2">
            <p class="text-sm text-gray-500">
              {{ selected_frame.takeaway != "undefined" ? selected_frame.takeaway : "No description"}}
            </p>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:gap-3 sm:grid-flow-row-dense"
           :class="{'sm:grid-cols-1 px-2 md:px-0': isGuest, 'sm:grid-cols-3': !isGuest}">

        <button type="button" class="btn" @click="presentShootingFrame()" v-show="!isGuest" :disabled="presentationMode" :class="presentationMode ? 'btn-disabled' : 'btn-primary'">
          {{ presentationMode ? 'Showing to everybody' : 'Show to everybody' }}
        </button>
        <button type="button" data-e2e="complete_test" class="btn btn-secondary sm:col-start-2 sm:text-sm"
                @click="toggleComplete()" v-if="!isGuest">
          <span v-if="selected_frame.completed_at">Undo</span>
          <span v-else>Mark as complete</span>
        </button>
        <button type="button" class="btn btn-secondary w-full" data-e2e="cancel_test" @click="closeLightbox()">
          Close
        </button>
      </div>
    </modal>
    <modal :showModal="showUploadFolderModal" @close="showUploadFolderModal = false" class-size="sm:max-w-2xl">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Folder add icon -->
        <svg class="h-6 w-6 fill-current text-green-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             fill="none" viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M2 6C2 4.89543 2.89543 4 4 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289L11.4142 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM8.58579 6L4 6V18H20V8H11C10.7348 8 10.4804 7.89464 10.2929 7.70711L8.58579 6ZM12 10C12.5523 10 13 10.4477 13 11V12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11V11C11 10.4477 11.4477 10 12 10Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline-upload-folder">
        Select a folder to upload
        </h3>
        <div class="mt-2">
        Your frames must be in JPEG or PNG format. They will appear in alphabetical order.
        </div>
      </div>
      <div class="flex justify-center" v-show="!formIsValid">
        <div class="w-48 px-4 mt-5 mx-auto">
          <input class="folder-input w-full" id="inputShootingBoard" type="file" multiple
                 @change="filesChange($event.target.files[0].webkitRelativePath.split('/')[0], $event.target.files); fileCount = $event.target.files.length"
                 webkitdirectory mozdirectory>
        </div>
      </div>
      <div class="flex justify-end mt-5 px-4" v-show="formIsValid">
        <button @click="resetUploadFolder(true)" class="btn btn-secondary">
        Change folder
        </button>
      </div>

      <div>
        <table class="w-full mt-5">
          <tbody>
          <tr v-for="(fd, i) in filesData">
            <td class="mt-1 flex flex-wrap">
              <div class="w-1/5 px-4 h-12 overflow-hidden">
                <img :id="'shootingBoardFrameUploaded_'+i" src="" class="min-w-full min-h-full rounded-md"/>
              </div>
              <div class="w-2/5 flex flex-wrap">
                <div class="w-full px-2">
                  <input type="text" :name="'titles'+i" v-model="filesNames[i]" placeholder="Frame 1"
                         class="h-12 form-input">
                </div>
              </div>
              <div class="w-2/5 flex flex-wrap">
                <div class="w-full px-2">
                  <input type="text" :name="'takeaway_'+i" v-model="filesTakeaways[i]"
                         placeholder="Enter the frame description"
                         class="h-12 form-input">
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-5 sm:mt-6 sm:grid sm:gap-3 sm:grid-flow-row-dense" :class="formIsValid ? 'sm:grid-cols-2': 'sm:grid-cols-1'">
        <button type="button" @click="createFolder" :disabled="!formIsValid" class="btn sm:col-start-2 overflow-hidden sm:text-sm"
                :class="formIsValid ? 'btn-primary' : 'btn-disabled'" data-e2e="create_stills_folder"
                v-show="formIsValid">
          Upload
        </button>

        <button type="button" class="btn btn-secondary" @click="resetUploadFolder()">
          Cancel
        </button>
      </div>

    </modal>
  </div>
</template>
<script>
import axios from 'axios'
import messageBroker from 'general/messageBroker';
import {localNotify} from 'utils/notifications';
import {addTask} from 'utils/status-indicator';

import commandsManager from 'general/CommandsManager'

export default {
  props: {
    isGuest: true,
  },
  data() {
    return {
      shooting_boards: [],
      isLoading: false,
      showLightbox: false,
      roomActivated: false,
      selected_frame: {},
      shooting_frames: [],
      selected_filter: 'show_all',
      selected_board: "none",
      // upload modal variables
      showUploadFolderModal: false,
      fileSizeInvalid: false,
      fileLimitInMB: 4,
      formData: {
        type: FormData
      },
      filesData: [],
      filesNames: [],
      filesTakeaways: [],
      uploadTask: {},
      processingCreateFolder: false,

      presentationMode: false
    }
  },
  computed: {
    formIsValid(){
      return !this.processingCreateFolder && this.filesData.length !== 0
    },
    filtered_shooting_frames: function () {
      if (this.selected_filter == 'show_all')
        return this.shooting_frames
      if (this.selected_filter == 'only_completed')
        return this.shooting_frames.filter(el => el.completed_at != null)
      if (this.selected_filter == 'only_not_completed')
        return this.shooting_frames.filter(el => el.completed_at == null)
    },
  },
  mounted() {
    // defer a bit the shooting board to not overload the user
    if (!this.isGuest){
      window.setTimeout(() =>{
        this.loadShootingBoards();
        this._loadShootingBoard();
        this.$root.$on('roomActivated', () => {
          this.roomActivated = true;
          // only reset folder id if the selected_board is not demo folder
          if (this.getCurrentFolder() == 'Demo folder'){
            this.selected_board = 'none';
          }
          this._loadShootingBoard();
        })
      }, 4000)
    }

    // set commands
    commandsManager
      .registerNewCommand('set_shooting_frame', (data) =>{
        this.updateShootingFrame(data.args);
      })
      .registerNewCommand('set_shooting_board', (data) =>{
        this.setShootingBoard(data.args);
      })
      .registerNewCommand('show_shooting_frame', (data) => {
        this.$emit('requestFocus', true)
        this.showShootingFrame(data.args.shooting_frame);
        // if the user is in fullscreen close the fullscreen
        // chrome and safari
        document.webkitCancelFullScreen && document.webkitCancelFullScreen();
        // firefox
        document.mozCancelFullScreen && document.mozCancelFullScreen();
        // ie 
        document.msExitFullscreen && document.msExitFullscreen();

      })
      .registerNewCommand('hide_shooting_board', () => {
        this.hideShootingBoard();
      })
  },
  methods: {
    loadShootingBoards(justBoards = false) {
      axios.get('/shooting_boards').then(response => {
        this.shooting_boards = response.data;
        if (this.shooting_boards == null) return;
        this.shooting_boards.forEach(sb => {
          if (sb.title == 'Demo folder' && !this.roomActivated) {
            // if none execute (wolfgreen)
            if(!justBoards) {
              this.selected_board = sb.id;
              this._loadShootingBoard();
            }
          }
        });
      });
    },
    _renderFrameLightbox(shooting_frame) {
      this.showLightbox = true;
      this.selected_frame = shooting_frame;
    },
    _loadShootingBoard(event) {
      if (this.selected_board === -1) {
        this.formData = new FormData();
        this.showUploadFolderModal = true;
        return;
      }
      var that = this;
      let id = this.selected_board;
      // if the "Select a folder is selected dont try and load
      if (id == 'none') {
        that.shooting_frames = []; // empty frames
        commandsManager.sendAllCommand('set_shooting_board', this.shooting_frames);
        return
      }


      let formData = new FormData();
      formData.append('authenticity_token', authenticity_token)

      var xhr = new XMLHttpRequest();
      xhr.responseType = 'json';
      xhr.open('GET', "/shooting_boards/" + id, true);
      xhr.onload = (e) => {
        var jsonResponse = xhr.response;
        if (jsonResponse && jsonResponse.shooting_board && jsonResponse.shooting_board.shooting_frames &&
            jsonResponse.shooting_board.shooting_frames.length > 0) {
          that.shooting_frames = jsonResponse.shooting_board.shooting_frames
          this.loadShootingBoards(true)
          commandsManager.sendAllCommand('set_shooting_board', that.shooting_frames)
          that.isLoading = false;
        } else {
          that.shooting_frames = []
        }
      };
      // Listen to the upload progress.
      // assuming you have a progress element on your dom
      xhr.upload.onerror = function (e) {
        console.log("Error", e)
      }
      xhr.onloadend = function () {
        if (xhr.status == 404) {
          commandsManager.sendAllCommand('set_shooting_board', {})
          that.shooting_frames = []
          that.isLoading = false;
        }
      }
      xhr.onerror = function () {
        that.isLoading = false;
      };

      xhr.send(formData);
      this.isLoading = true;
    },
    toggleComplete() {
      let id = this.selected_frame.id;
      let completed = this.selected_frame.completed_at == null;
      this._sendFormData(id, completed)
    },
    sendShootingBoard(peerId) {
      messageBroker.sendCommand('set_shooting_board', peerId, this.shooting_frames)
    },
    setShootingBoard(shooting_frames) {
      this.shooting_frames = shooting_frames;
    },
    updateShootingFrame(data) {
      var shooting_frames = this.shooting_frames
      for (var i = 0; i < this.shooting_frames.length; i++) {
        if (shooting_frames[i].id === data.id) {
          shooting_frames[i].completed_at = !data.completed ? null : new Date()
        }
      }
      this.shooting_frames = shooting_frames;
    },
    _sendFormData(id, completed) {

      var that = this;
      let formData = new FormData();
      formData.append('authenticity_token', authenticity_token)
      formData.append('shooting_frame[completed_at]', completed);

      var xhr = new XMLHttpRequest();
      xhr.responseType = 'json';
      xhr.open('PUT', "/shooting_frames/" + id, true);
      xhr.onload = function (e) {
        var jsonResponse = xhr.response;
        // completed is negated as the recieving function inverts it
        // markShootingFrameAsCompleted
        commandsManager.sendAllCommand('set_shooting_frame', {id, completed: completed})
        that.shooting_frames.find(frame => frame.id == id).completed_at = !completed ? null : new Date();
      };
      // Listen to the upload progress.
      // assuming you have a progress element on your dom
      xhr.upload.onerror = function (e) {

      }

      xhr.send(formData);
    },
    // Credits to docmars to fix jump top left flip
    // https://forum.vuejs.org/t/transition-group-leave-transition-w-position-absolute-jumping-to-top-left-flip/12258/4
    beforeLeave(el) {
      const {marginLeft, marginTop, width, height} = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`
      el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`
      el.style.width = width
      el.style.height = height
    },
    filterFiles(files){
      const filteredFiles = ['.DS_Store']
      const allowedType = 'image'
      return [...files].filter(file => file.type.includes('image'))
    },
    filesChange(fieldName, fileList) {
      this.formData = new FormData();
      this.filesData = [];
      this.filesNames = [];
      this.formData.append('shooting_board[title]', fieldName);
      const filteredFileList = this.filterFiles(fileList);
      Array
        .from(Array(filteredFileList.length).keys())
        .map(x => {
          if (filteredFileList[x].size > 4 * 1024 * 1024) return;
          this.formData.append('shooting_board[files][]', filteredFileList[x], filteredFileList[x].name);
          this.filesData.push(filteredFileList[x]);
          this.filesNames.push(filteredFileList[x].name.split('.')[0]);
        });
      this.filesData.forEach((x, i) => {
        let reader = new FileReader();
        reader.onload = function (e) {
          // get loaded data and render thumbnail.
          document.getElementById("shootingBoardFrameUploaded_" + i).src = e.target.result;
        };
        // read the image file as a data URL.
        reader.readAsDataURL(x);
      })
    },
    createFolder() {
      this.uploadTask = addTask({id: 'UPLOAD_SHOOTING_BOARD',
        determinate: true,
        message: 'Uploading shooting board...'
      })
      this.processingCreateFolder = true
      let url = '/shooting_boards/upload'
      //let formData = new FormData();
      this.formData.append('authenticity_token', authenticity_token);


      this.filesNames.forEach((x, index) => {
        this.formData.append('shooting_board[shooting_frames][][title]', x);
        this.formData.append('shooting_board[shooting_frames][][order]', index);
        if(this.filesTakeaways[index])
          this.formData.append('shooting_board[shooting_frames][][takeaway]', this.filesTakeaways[index]);
        else
          this.formData.append('shooting_board[shooting_frames][][takeaway]', "");
      })

      const xhr = new XMLHttpRequest();
      xhr.responseType = 'json';
      xhr.open('POST', url, true);
      xhr.onload = (e) => {
        const jsonResponse = xhr.response;
        this.showUploadFolderModal = false;
        this.loadShootingBoards()
        this.processingCreateFolder = false
        this.uploadTask.done();
        this.resetUploadFolder();
      };
      // Listen to the upload progress.
      // assuming you have a progress element on your dom
      // var progressBar = document.querySelector('progress#upload');

      xhr.upload.onprogress =  (e) => {
        if (e.lengthComputable) {
          this.uploadTask.update(parseInt(e.loaded / e.total * 100, 10));
          // progressBar.value = (e.loaded / e.total) * 100;
          // progressBar.textContent = progressBar.value; // Fallback for unsupported browsers.
        }
        if ((e.loaded / e.total) === 1) {
          // finished upload
        }
      };
      xhr.upload.onerror =  (e) => {
        this.uploadTask.error();
        this.processingCreateFolder = false
        // $('#uploadingNow').addClass('hidden');
        // handleError(`Error ${xhr.status} occurred uploading your file`);
        // uploadTask.error();

      }
      xhr.send(this.formData);
    },
    resetUploadFolder(showModal = false){
      this.showUploadFolderModal = showModal;
      this.selected_board = 'none';
      document.getElementById('inputShootingBoard').value = null;
      this.formData = new FormData();
      this.filesData = [];
      this.filesNames = [];
    },
    getCurrentFolder(){
      let folder = this.shooting_boards.find(x => x.id === this.selected_board)
      if (folder == null) return;
      return folder.title;
    },
    presentShootingFrame(){
      this.presentationMode = true;
      commandsManager.sendAllCommand('show_shooting_frame', { shooting_frame: this.selected_frame } );
    },
    closeLightbox(){
      if(this.presentationMode == true){
        commandsManager.sendAllCommand('hide_shooting_board');
      }
      this.showLightbox = false;
      this.presentationMode = false;
    },
    showShootingFrame(shooting_frame){
      this._renderFrameLightbox(this.shooting_frames.find(frame => frame.id == shooting_frame.id));
    },
    hideShootingBoard(){
      this.showLightbox = false;
    },
  }
}
</script>
<style lang="scss">
.slide-in-item {
  transition: all 0.3s;
  transform-origin: bottom;
}

.slide-in-enter
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: scale(0.8) translateY(30px);
}

.slide-in-leave-to {
  opacity: 0;
  transform: scale(0.8) translateY(-30px);
}

.slide-in-enter-active {
  transition-duration: 200ms;
  transition-delay: 300ms;
  //    position: absolute; // so theres no empty spots in transition
}

.slide-in-leave-active {
  transition-duration: 300ms;
  position: absolute; // so theres no empty spots in transition
}

</style>
